module.exports = __webpack_public_path__ + "static/media/banner2.4dbbf66c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/images/banner2.jpg
// module id = 96
// module chunks = 0